import apiService from '../../../services/apiService';
import axios from 'axios';

const CAMP_API = '/ykrestapi/CampChannel';
const API_BASE_URL = process.env.REACT_APP_YK_API_BASE || 'http://localhost:5000/ykrestapi';

const volunteerService = {
  getCenters: async (countryDesc = 'USA') => {
    const response = await apiService.post(`${CAMP_API}/GetCenterForCamp`, {
      Country_Desc: countryDesc,
    });
    return response.data;
  },

  insertVolunteer: async (payload, signal) => {
    const response = await apiService.post(`${CAMP_API}/InsertVolunteer`, payload, { signal });
    return response.data;
  },

  sendConfirmationEmail: async (payload, signal) => {
    const response = await axios.post(
      `${API_BASE_URL}/MessageChannel/SendEmailMessage?appName=Waiver&templateName=VolunteerWaiver&orgId=3`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  },
};

export default volunteerService;
